import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-275" data-mp="32onj8zjvni7d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-276" data-mp="36oxzd51dvozy">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-277" data-mp="36nd75m2jki59">
          {/* Company Info */}
          <div className="lg:col-span-1" data-id="element-278" data-mp="38qu4u3bljp2">
            <a href="#" className="inline-flex items-center mb-6 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-4 focus-visible:ring-offset-gray-950" data-id="element-279" data-mp="37o2ul235f8m">
              <Logo variant="dark" size="sm" data-id="element-280" data-mp="29z6tk9nn6feu" />
            </a>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-281" data-mp="29xlzsm95j0i1">
              Marketing Experts at Driving & Turning Traffic into Conversions
              with a Focus on Building Customer Loyalty & Retention.
            </p>
            <div className="space-y-3 text-sm" data-id="element-282" data-mp="3lbdaunotrzj6">
              <a href="tel:17022134801" className="flex items-center hover:text-white transition-colors" data-id="element-283" data-mp="3gbijyk51v9y4">
                <PhoneIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-284" data-mp="3q8mz400ha55f" />
                (702) 213-4801
              </a>
              <a href="mailto:Results@GetAdROI.com" className="flex items-center hover:text-white transition-colors" data-id="element-285" data-mp="82ienymgqkhh">
                <MailIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-286" data-mp="31up7hdvubpd" />
                Results@GetAdROI.com
              </a>
              <div className="flex items-start" data-id="element-287" data-mp="ctqrz5qwypzx">
                <MapPinIcon className="w-4 h-4 mr-3 text-gray-500 mt-1 flex-shrink-0" data-id="element-288" data-mp="cu8tohwchwf8" />
                <span data-id="element-289" data-mp="quji7ea6myx8">
                  4730 S. Fort Apache Rd., Suite 300
                  <br data-id="element-290" data-mp="msg6cojlpsbf" />
                  Las Vegas, NV 89147
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-291" data-mp="tt9z0dyrgtw6">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-292" data-mp="yu7iquzf5vzs">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-293" data-mp="13t0y6sy9nx2l">
              <li data-id="element-294" data-mp="13r7nn2kj8spb">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-295" data-mp="18k0ubvzkab41">
                  Search Engine Optimization
                </a>
              </li>
              <li data-id="element-296" data-mp="1clckc2mckycr">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-297" data-mp="1cnyqpyxi57te">
                  Pay-Per-Click Advertising
                </a>
              </li>
              <li data-id="element-298" data-mp="1ml3gs9ugxnfh">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-299" data-mp="1mkjvqk9iuix8">
                  Web Design & Development
                </a>
              </li>
              <li data-id="element-300" data-mp="3obx0n9bhoqta">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-301" data-mp="3ocghsntbfb69">
                  CRM Implementation
                </a>
              </li>
              <li data-id="element-302" data-mp="2af3upvql3dm9">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-303" data-mp="2afn76wxgt9sw">
                  Conversion Rate Optimization
                </a>
              </li>
              <li data-id="element-304" data-mp="25mkess4fc6ea">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-305" data-mp="21mjzl59i3r66">
                  Social Media Marketing
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-306" data-mp="2te9cko00ln2m">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-307" data-mp="2tcy62gf6q17t">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-308" data-mp="2pd5urvyepgyr">
              <li data-id="element-309" data-mp="2kcrxn8ycfrfi">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-310" data-mp="2kc8iu13zpj5p">
                  About Us
                </a>
              </li>
              <li data-id="element-311" data-mp="2fgkrbf21cdx1">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-312" data-mp="18xuwx1ssrdsb">
                  Our Process
                </a>
              </li>
              <li data-id="element-313" data-mp="13y9u2gaialab">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-314" data-mp="13xqgtcvswl2m">
                  Case Studies
                </a>
              </li>
              <li data-id="element-315" data-mp="2wmzjwjvx0pwq">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-316" data-mp="2wnhk1rlp7o9x">
                  Careers
                </a>
              </li>
              <li data-id="element-317" data-mp="2it86h0f2clvq">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-318" data-mp="2ntw7mex0aj3o">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-319" data-mp="3fl1zk82kpahv">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-320" data-mp="3flljfubsa8yj">
              Resources
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-321" data-mp="31l0zuvy1o93z">
              <li data-id="element-322" data-mp="36kdn3hstvi73">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-323" data-mp="36juc6l1lhu2k">
                  Marketing Blog
                </a>
              </li>
              <li data-id="element-324" data-mp="1q8glrf97au06">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-325" data-mp="1v5grtq61vwra">
                  ROI Calculator
                </a>
              </li>
              <li data-id="element-326" data-mp="1nkmu4p1tpbct">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-327" data-mp="1no281ojrgecn">
                  Free SEO Audit
                </a>
              </li>
              <li data-id="element-328" data-mp="1wmw0d2q26ike">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-329" data-mp="1wlcjpb0hq5i3">
                  Help Center
                </a>
              </li>
            </ul>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-330" data-mp="13xp1g2mozqym">
              Follow Us
            </h4>
            <div className="flex space-x-4" data-id="element-331" data-mp="zxek5ttg9e4g">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-332" data-mp="zuk0w5m69zcm">
                <FacebookIcon className="w-5 h-5" data-id="element-333" data-mp="18wjmlb84trlw" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-334" data-mp="18v8j7cilmlvb">
                <TwitterIcon className="w-5 h-5" data-id="element-335" data-mp="g95srlzqdc60" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-336" data-mp="2gan75yt2jgyo">
                <InstagramIcon className="w-5 h-5" data-id="element-337" data-mp="2l8oqmkuepiao" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-338" data-mp="2q0oyczgpxfht">
                <LinkedinIcon className="w-5 h-5" data-id="element-339" data-mp="2uyi4xtlxobim" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-340" data-mp="1xdcc6qegz9p1">
          <p data-id="element-341" data-mp="279ytx6bi1kmu">
            &copy; {new Date().getFullYear()} AdROI Marketing & Conversions. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-342" data-mp="2bbspj06u7yg5">
            <a href="#" className="hover:text-white transition-colors" data-id="element-343" data-mp="2b97pmgq3nsl1">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-344" data-mp="3mqft8zsx94o5">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-345" data-mp="1b3m25g15kp45">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}